<template>
  <div class="min-h-screen p-4">
    <!-- 搜索区域 -->
    <div class="flex items-center mb-4">
      <label class="text-gray-700 font-medium mr-2">客户姓名:</label>
      <input
          v-model="customerName"
          class="border border-gray-300 rounded-md p-2 focus:ring-blue-500 focus:border-blue-500"
          placeholder="请输入客户姓名"
      />
      <button
          @click="fetchRecords"
          class="ml-2 py-2 px-4 rounded-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50"
      >
        查询
      </button>
    </div>

    <!-- 表格区域 -->
    <div class="mt-4 overflow-x-auto"> <!-- 添加水平滚动条支持 -->
      <!-- 表格区域 -->
      <table class="w-full border-collapse">
        <thead>
        <tr>
          <th class="border px-4 py-2 fixed-width-name">客户姓名</th>
<!--          <th class="border px-4 py-2 fixed-width-hospital">就诊医院</th>-->
          <th class="border px-4 py-2 fixed-width-disease">病情描述</th>
          <th class="border px-4 py-2 fixed-width-time">创建时间</th>
          <th class="border px-4 py-2 operation">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="record in records" :key="record.id" @click="goToDetail(record)">
          <td class="border px-4 py-2 fixed-width-name break-words">{{ record.customer_name }}</td>
<!--          <td class="border px-4 py-2 fixed-width-hospital break-words">{{ record.visit_hospital }}</td>-->
          <td class="border px-4 py-2 fixed-width-disease break-words">{{ record.patient_disease }}</td>
          <td class="border px-4 py-2 fixed-width-time break-words">{{ formatDate(record.created_at) }}</td>
          <td class="border px-4 py-2">
            <a href="javascript:void(0)"
               @click="goToDetail(record)"
               class="text-blue-600 hover:text-blue-800 font-medium transition-all duration-200 flex items-center justify-center gap-1">
              <i class="fa fa-eye"></i>
              <span>详情</span>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { api } from '@/api'
import { useRouter } from 'vue-router/composables'
import { useToastStore, useUserStore } from '@/stores'

const customerName = ref('')
const records = ref([])
const router = useRouter()
const { $toast } = useToastStore()
const userStore = useUserStore()

// 格式化日期函数
const formatDate = (isoDate) => {
  if (!isoDate) return ''
  return new Date(isoDate).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' })
}

const fetchRecords = async () => {
  try {
    const { data } = await api.get('/escorth5/serv_order/record_list', {
      params: {
        customer_name: customerName.value,
        pageSize: 100,
      },
    })
    records.value = data.data || []
  } catch (error) {
    $toast('查询失败，请重试')
  }
}

const goToDetail = (record) => {
  router.push(`/record-detail/${record.id}`)
}

onMounted(() => {
  fetchRecords()
})
</script>

<style scoped>
/* 固定列宽类 */
.fixed-width-name {
  width: 130px; /* 客户姓名列宽度 */
}

.fixed-width-hospital {
  width: 150px; /* 就诊医院列宽度 */
}

.fixed-width-disease {
  width: 160px; /* 病情描述列宽度 */
}

.fixed-width-time {
  width: 140px; /* 创建时间列宽度 */
}
.operation{
  width: 80px; /* 创建时间列宽度 */
}
/* 允许内容换行 */
.break-words {
  white-space: normal; /* 允许换行 */
  word-wrap: break-word; /* 长单词或URL自动换行 */
  word-break: break-all; /* 强制内容在边界内换行 */
}
</style>